import { useEffect } from 'react';
import { useMap } from '@vis.gl/react-google-maps';
export const Polyline = ({ path, options }) => {
    const map = useMap();
    useEffect(() => {
        if (!map)
            return undefined;
        const polyline = new google.maps.Polyline(Object.assign(Object.assign({}, options), { path }));
        polyline.setMap(map);
        return () => {
            polyline.setMap(null);
        };
    }, [map, path, options]);
    return null;
};
